import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Recruiter, Studies} from '../model/recruiter.model';
import {StudiesService} from '../../shared/services/studies.service';
import {MatSidenav} from '@angular/material/sidenav';
import {FormControl, NgForm, Validators} from '@angular/forms';
import {RecruiterServices} from '../../shared/services/recruiter.services';
import { NotifierService } from 'angular-notifier';
import { LoginService } from 'src/app/services/login.service';
import { Router } from '@angular/router';


@Component({
  selector: 'app-edit',
  templateUrl: './edit.component.html',
  styleUrls: ['./edit.component.scss']
})
export class EditRecruiterComponent implements OnInit {
  @Input() allStudies: Studies ;
  @Input() selectedRecruiter:any = {};
  @Input() inputSideNav: MatSidenav;
  @Output() close: EventEmitter<any> = new EventEmitter();
  formatedStudy: any = [];
  fetchedStudies: Studies;
  public selectedStudy = [];
  public recruiterStudy = [];
  public study_count: any;
  public assignedStudy: boolean = false;
  public assigned_study_id: any = [];
  active = true;
  private recruiter: Recruiter;
  formStatus = false;
  statusClass: string;
  responseMessage:string;
  responseIcon: string;
  countryDetails:any = {code:'+91',name:'India'};
  countryList:any = [];



  constructor(
    private studiesService: StudiesService,
    private notifier: NotifierService, 
    private logerror: LoginService,
    private router: Router,
    private recruiterService: RecruiterServices ) {
  }
  ngOnInit() {
    this.fetchedStudies = this.allStudies;
    // this.recruiter = new Recruiter({
    //   recruiter_name: '', phone: '', employee_id: '', recruiter_code: ''
    // });
    this.recruiter = this.selectedRecruiter;
    this.getAllCountry();

    this.formatStudyFn (this.fetchedStudies.result );
    return this.studiesService.getStudyByRecruiter(this.recruiter.id).subscribe(
      data => {
        if (data.responseCode == 1) {
          this.study_count = data.study_count;
          data.result.filter(study => {
            this.recruiterStudy.push(study);
          })
          this.assignedStudy = true
        } else {

        }
      },
      error =>{
        if(error.status == 401){
          this.router.navigate(['home/access-denied']);
        }
      }
    )
  }
  formatStudyFn(value: any) {
    value.filter( study => {
      this.formatedStudy.push({name: study.study_details.study_name, id: study.study_details.id});
    });
  }
  onStudyAssign() {
    this.assigned_study_id = [];
    this.selectedStudy.filter(study => this.assigned_study_id.push(study.id));
    this.studiesService.assignStudy({recruiter_id: this.selectedRecruiter.id, study: this.assigned_study_id.toString()}).subscribe(data => {
    }, error=>{
      if(error.status == 401){
        this.router.navigate(['home/access-denied']);
      }
    })
  }

  selectedStudyHandler($event: any) {
    this.selectedStudy = $event;
  }
  onUpdateRecruiter(f: NgForm){
    this.recruiterService.updateRecruiter(this.recruiter.id,this.recruiter).subscribe(data=>{
      if ( data.responseCode == 1){
        this.statusClass = 'success';
        this.showNotification('success','Successfully Edited');
        this.responseIcon ='check_circle_outline';
        this.formStatus = true;
        // const recruiter =  data.result.result;
        this.responseMessage = 'You have updated successfully'
        // this.assignStudy(recruiter, this.selectedStudy);
        // this.resetForm(f);
        this.onClose();

      }
      else{
        this.statusClass = 'fail';
        this.responseIcon ='error_outline';
        this.responseMessage = 'Oops ! Error'
        this.formStatus = true;
        this.showNotification('error','Failed Edited');

      }
    },
    (error)=>{
      if(error.status == 401){
        this.router.navigate(['home/access-denied']);
    }else{
      this.showNotification('error','Something Went Wrong');
    }
    })

  }
  onClose(){
    this.close.emit();
  }
  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;

  }
  scrollToTarget(element: HTMLElement){
    element.scrollIntoView(true);
  }

  getAllCountry(){
    this.recruiterService.getAllCountry().subscribe((data)=>{
      this.countryList = data['countries'];
      this.countryList.forEach(country => {
        if(country['id'] === this.recruiter['country_id']){
          this.countryDetails.name = country['name'];
          this.countryDetails.code = country['extension'];
        }
      });
    }, error=>{
      if(error.status == 401){
        this.router.navigate(['home/access-denied']);
      }else{
        this.notifier.notify('error', 'Something went wrong');
      }
    });
  }
  
  public showNotification( type: string, message: string ): void {
		this.notifier.notify( type, message );
	}

	public hideOldestNotification(): void {
		this.notifier.hideOldest();
	}
}

